export default "__VITE_ASSET__e3879592__"